import { get, post } from './http-calls';
import { memoize } from 'lodash';

export const getChecksAddTabByID = async (id, checkID, ScheduleEventID, ScheduleID) => {
    let res = await get(`VehicleInspection/AddScreenDetails?Id=${id}`, { useAuthToken: true });
    return res;
};
export const getTyreCheckData = async (vehicleID) => {
    let res = await get(`VehicleInspection/VehicleInspections_GetPreviousAxles?VehicleID=${vehicleID}`, { useAuthToken: true });
    return res;
};

export const postChecksData = async (data) => {
    let res = await post(`VehicleInspection`, data, { useAuthToken: true });
    return res;
};

export const getChecksEditByID = async (id, checkID) => {
    let res = await get(`VehicleInspection/EditScreenDetails?Id=${id}`, { useAuthToken: true });
    return res;
};

export const getChecks = async (id) => {
    let res = await get(`VehicleInspection/list`, { useAuthToken: true });
    return res;
};

export const getSingleChecks = async (id) => {
    let res = await get(`VehicleInspection/DefectDetails?ResultID=${id}`, { useAuthToken: true });
    return res;
};

export const postSingleChecksData = async (data) => {
    let res = await post(`VehicleInspection/DefectDetails `, data, { useAuthToken: true });
    return res;
};

export const PostImage = async (data) => {
    let res = await post(`VehicleInspectionsPhoto`, data, { useAuthToken: true });
    return res;
};
export const getImageByID = async (id) => {
    let res = await get(`VehicleInspectionsPhoto/${id}`, { useAuthToken: true });
    return res;
};
export const deleteImageByID = async (id) => {
    let res = await post(`VehicleInspectionsPhoto/Delete/${id}`, { useAuthToken: true });
    return res;
};
export const VehicleInspections_ReturnToTech = async (data) => {
    let res = await post(`VehicleInspection/VehicleInspections_ReturnToTech`, data, { useAuthToken: true });
    return res;
};

export const getGenerateVehicleInspectionReportPdf = async (id, checkID) => {
    let res = await get(`VehicleInspection/GenerateVehicleInspectionReport/${id}?DisplayCheck=${checkID}`, { useAuthToken: true });
    return res;
};

export const getVehicleContractByStatusXLSX = async (StatusID) => {
    let res = await get(
        `VehicleContract?StatusID=${StatusID}&Filetype=${'excel'}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        },
        { useAuthToken: true }
    );

    return res;
};

export const getTitleData = async (id) => {
    let res = await get(`Vehicles/VehicleGetTitleData/${id}`, { useAuthToken: true });
    return res;
};
export const getVehicleById = async (Id) => {
    let res = await get(`vehicles/${Id}`, { useAuthToken: true });
    return res;
};

export const getCompleteScheduleDropdowns = async () => {
    let res = await get(`VehicleInspection/VehicleInspection_DropDowns`, { useAuthToken: true });
    return res;
};
